import DCentTutorialComponent from './DCentTutorialComponent'
import LedgerTutorialComponent from './LedgerTutorialComponent'
import TrezorTutorialComponent from './TrezorTutorialComponent'

export { DCentTutorialComponent, LedgerTutorialComponent, TrezorTutorialComponent }
